var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPenTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_237_4148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8812 22.9702C20.7478 23.1994 20.5288 23.3661 20.2724 23.4339C20.0161 23.5016 19.7433 23.4647 19.5141 23.3314L17.5756 22.2031C17.3464 22.0697 17.1797 21.8507 17.1119 21.5944C17.0442 21.338 17.0811 21.0652 17.2144 20.836L21.1882 14.0085C21.3217 13.7793 21.5406 13.6125 21.797 13.5448C22.0534 13.4771 22.3261 13.5139 22.5553 13.6473L24.4938 14.7756C24.723 14.909 24.8898 15.128 24.9575 15.3843C25.0252 15.6407 24.9884 15.9135 24.855 16.1427L20.8812 22.9702Z",
    stroke: "#787777",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9821 14.3665L17.8969 8.07176C17.813 7.90049 17.6818 7.7568 17.5189 7.65763C17.356 7.55847 17.1681 7.50795 16.9774 7.51205L3.90432 7.52997C3.73298 7.53358 3.56545 7.58117 3.4178 7.66815C3.27014 7.75514 3.14732 7.87861 3.06112 8.02672C2.97491 8.17483 2.92822 8.34261 2.92551 8.51396C2.9228 8.68531 2.96418 8.85448 3.04567 9.00524L9.48718 20.3812C9.57779 20.5491 9.71451 20.6875 9.8812 20.7801C10.0479 20.8728 10.2376 20.9159 10.428 20.9043L17.4252 20.4778M3.06981 8.03178L11.9752 13.215",
    stroke: "#787777",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2132 16.1548C15.2811 15.8726 15.9181 14.7782 15.636 13.7103C15.3538 12.6423 14.2594 12.0053 13.1915 12.2875C12.1235 12.5696 11.4865 13.6641 11.7687 14.732C12.0508 15.7999 13.1453 16.4369 14.2132 16.1548Z",
    stroke: "#787777",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_237_4148"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.257812 6.39551) rotate(-14.7993)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenTool);
export default __webpack_public_path__ + "static/media/pen-tool.310352ea58f13710a378b0aa99e90044.svg";
export { ForwardRef as ReactComponent };